var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props.item.deletedAt)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g({staticClass:"cursor-pointer",attrs:{"color":"red"}},on),[_vm._v("mdi-flag")])]}}],null,false,2091054199)},[_c('span',{domProps:{"textContent":_vm._s(_vm.__('company.components.task-types.deleted-flag.tooltip-text', { date: _vm.props.item.deletedAt }))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }